<template>
    <div>
        <v-dialog v-model="dialog_confimation" persistent no-click-animation transition="slide-y-transition" max-width="290">
          <v-card>
            <v-card-title class="title noshadow">{{header}}</v-card-title>
            <v-card-text class="pt-0 pl-4" v-html="confirmationMessage"></v-card-text>
            <v-divider></v-divider>
            <v-card-actions style="padding:6px 0px;">
                <v-layout ma-0 row wrap>
                    <v-flex xs6 sm6 md6 center-align :class="{'border-right':!hideClose}">
                        <v-btn small font-heavy capitalize dark-opacity-color text @click="fn_closeDialog" v-if="!hideClose">{{cancelBtnText ? cancelBtnText : $t('common.close')}}</v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md6 center-align>
                        <v-btn small font-heavy capitalize class="primary-color" text @click="actionMethod(params)">{{okBtnText ? okBtnText : $t('common.ok')}}</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
           <!--  <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="blue darken-1" text @click="fn_closeDialog">{{cancelBtnText ? cancelBtnText : 'Close'}}</v-btn>
                <v-btn small color="blue darken-1" text @click="actionMethod(params)">{{okBtnText ? okBtnText : 'Ok'}}</v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>
    </div>
</template>     

<script>

export default{
    props:['header', 'confirmationMessage', 'actionMethod', 'displayView', 'params', 'okBtnText', 'cancelBtnText', 'hideClose'],
    data(){ 
        return{
            dialog_confimation: false,
        }
    },
    methods: {
        openDialogWeb: function () {    
            this.dialog_confimation = true;
        },
        closeDialogWeb: function () {
            this.dialog_confimation = false;
        },
        fn_closeDialog: function(){
            if(this.displayView){
                this.closeDialogWeb();
            }
            else{
                this.$parent.fn_closeDialog();
            }
        }
    }
}
</script>